import {ExclamationCircleOutlined, MoreOutlined} from "@ant-design/icons";
import {Button, Dropdown, Menu, Modal, message} from "antd";
import {Link} from "react-router-dom";
import {useDigitalProductMutations} from "../../../../../features/digital-products";
import {handleProductLink} from "../../../../../utils/products";
import {useGetProfileContext} from "../../../../../context/profile/profile-context";

type TProductListMenuOptionProps = {
  productId: number;
  slug: string;
  tinyUrl: string;
  statusId: string;
};

export function ProductListMenuOption({
  productId,
  slug,
  statusId,
  tinyUrl,
}: TProductListMenuOptionProps) {
  const {deleteProduct, isDeleting} = useDigitalProductMutations();
  const {state: profileState} = useGetProfileContext();

  const handleDeleteModal = () => {
    Modal.confirm({
      title: `Confirm product deletion`,
      content:
        "Are you sure you want to delete this product? This action cannot be undone.",
      icon: <ExclamationCircleOutlined style={{color: "#F5222D"}} />,
      okText: "Delete product",
      cancelText: "Exit",
      okType: "danger",
      okButtonProps: {
        size: "small",
        type: "primary",
        loading: isDeleting,
      },
      cancelButtonProps: {
        size: "small",
        type: "ghost",
      },
      onOk() {
        return new Promise((resolve, reject) => {
          if (productId) {
            resolve(
              deleteProduct(productId, {
                onSuccess: () => {
                  message.success("The selected product has been deleted successfully!");
                },
                onError: (error) => {
                  message.error(
                    error.response?.data?.message ||
                      error.message ||
                      "Failed to delete product"
                  );
                },
              })
            );
          }
        }).catch(() => message.error("Failed to delete"));
      },
    });
  };
  const menu = (
    <Menu
      items={[
        {
          label: (
            <Link to={`/products/edit/${productId}?activeTab=insights`}>
              Sales and insights
            </Link>
          ),
          key: "0",
        },
        {
          label: <Link to={`/products/edit/${productId}`}>Edit product</Link>,
          key: "1",
        },
      ].concat(
        +statusId === 1
          ? [
              {
                label: (
                  <div
                    onClick={() =>
                      navigator.clipboard
                        .writeText(
                          handleProductLink({
                            productId: productId,
                            slug: slug,
                            username: profileState.profileData.username,
                            tinyUrl: tinyUrl,
                            windowNav: true,
                          })
                        )
                        .then(() => message.success("Copied link"))
                    }
                  >
                    Copy product link
                  </div>
                ),
                key: "2",
              },
              {
                label: <div onClick={handleDeleteModal}>Delete product</div>,
                key: "3",
              },
            ]
          : [
              {
                label: <div onClick={handleDeleteModal}>Delete product</div>,
                key: "3",
              },
            ]
      )}
    />
  );
  return (
    <>
      <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
        <Button
          shape="circle"
          size="small"
          icon={<MoreOutlined />}
          style={{
            backgroundColor: "transparent",
            color: "#1C1726",
            border: "none",
            boxShadow: "none",
          }}
        />
      </Dropdown>
    </>
  );
}
